export default "__VITE_ASSET__DQU3MNhV__"